import { DemandConversationDrawerHeader } from '../DemandConversationDrawerHeader/DemandConversationDrawerHeader';
import { ResizeableDrawer } from '~/components/ResizeableDrawer/ResizeableDrawer';
import { OpenCloseProps } from '~/hooks';
import { useDemandDetail } from '~/modules';
import { DemandConversation } from '~/routes/DemandConversation/DemandConversation';

interface DemandConversationDrawerProps extends OpenCloseProps {
  sequenceNumber: string;
  hasTabs?: boolean;
}

export const DemandConversationDrawer = ({ sequenceNumber, hasTabs, ...openClose }: DemandConversationDrawerProps) => {
  const { demandId } = useDemandDetail();
  const { open, onClose } = openClose;

  return (
    <ResizeableDrawer {...openClose} hasTabs={hasTabs}>
      <DemandConversation
        demandId={demandId}
        sequenceNumber={sequenceNumber}
        skip={!open}
        header={<DemandConversationDrawerHeader onClose={onClose} />}
      />
    </ResizeableDrawer>
  );
};
